(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
const showDinersCartReturn = () => {
  const plan = new URLSearchParams(location.search).get('stella_plan');
  document.querySelectorAll('[data-diners-empty-return]').forEach((link) => {
    link.hidden = plan !== 'monthly' && plan !== 'annual';
  });
};
showDinersCartReturn();
window.addEventListener('pageshow', showDinersCartReturn);

// Use Shopify's server-rendered, item-specific url_to_remove. Deleting a row
// must not depend on an Ajax cart preflight or the browser parsing cart.js.
// Shopify applies the same server-side cart/checkout validation to this route.
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('[data-stella-cart-remove]');
  if (!link || !link.closest('.cart-page')) return;
  if (window.StellaCartState?.busy) event.preventDefault();
}, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stella-join-entry"] && !Shopify.designMode) return;
  try {
    
function stellaJoinHighlight() {
  const selectedPlan = new URLSearchParams(window.location.search).get('plan');
  document.querySelectorAll('.stella-join-entry [data-stella-plan]').forEach((card) => {
    const selected = card.dataset.stellaPlan === selectedPlan;
    card.dataset.selected = String(selected);
    const badge = card.querySelector('.sj-selected');
    if (badge) badge.hidden = !selected;
    const entry = card.querySelector('[data-stella-entry]');
    if (selected && entry) entry.querySelector('[data-cta-label]').textContent = entry.dataset.continueLabel;
  });
}
stellaJoinHighlight();
document.addEventListener('shopify:section:load', stellaJoinHighlight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stella-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stella-product')) {
    customElements.define('stella-product', class extends HTMLElement {
      connectedCallback() {
        this.variant = this.querySelector('[data-stella-variant]');
        this.price = this.querySelector('[data-stella-price]');
        this.submit = this.querySelector('[data-stella-submit]');
        this.submitText = this.querySelector('[data-stella-submit-text]');
        this.form = this.querySelector('.st-product__form');
        this.isMembershipProduct = this.dataset.membershipProduct === 'true';
        this.variant?.addEventListener('change', () => this.updateVariant());
        this.querySelectorAll('[data-stella-selling-plan]').forEach((select) => {
          select.addEventListener('change', () => this.updateSellingPlan(select));
        });
        this.form?.addEventListener('submit', (event) => this.submitMembership(event), true);
        this.querySelectorAll('[data-stella-thumb]').forEach((thumb) => {
          thumb.addEventListener('click', () => this.updateImage(thumb));
        });
        this.updatePurchaseState();
      }

      async submitMembership(event) {
        if (!this.isMembershipProduct) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.submitting) return;
        const sellingPlan = this.activeSellingPlan;
        if (!sellingPlan?.value || !this.form.reportValidity()) {
          sellingPlan?.reportValidity();
          return;
        }
        const errorBox = this.querySelector('[data-stella-request-error]');
        errorBox.hidden = true;
        errorBox.textContent = '';
        const consentedAt = this.querySelector('[data-stella-consented-at]');
        if (consentedAt) consentedAt.value = new Date().toISOString();
        const body = new FormData(this.form);
        body.set('id', this.variant.value);
        body.set('quantity', '1');
        body.set('selling_plan', sellingPlan.value);
        body.delete('return_to');
        this.submitting = true;
        this.submit.disabled = true;
        this.submitText.textContent = this.dataset.submittingLabel;
        let succeeded = false;
        try {
          const response = await fetch(`${this.form.action}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            body,
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            const description = typeof result.description === 'string' ? result.description : '';
            const errors = Array.isArray(result.errors) ? result.errors.map((error) => typeof error === 'string' ? error : error.message).filter(Boolean).join(' ') : '';
            throw new Error(description || errors || this.dataset.requestError);
          }
          succeeded = true;
          window.location.assign(this.dataset.checkoutUrl);
        } catch (error) {
          errorBox.textContent = error.message || this.dataset.requestError;
          errorBox.hidden = false;
          errorBox.focus();
        } finally {
          if (!succeeded) {
            this.submitting = false;
            this.updatePurchaseState();
          }
        }
      }

      get activeSellingPlan() {
        return this.querySelector('[data-stella-selling-plan-field]:not(.st-product__selling-plan-field--hidden) [data-stella-selling-plan]');
      }

      updateVariant() {
        const option = this.variant.options[this.variant.selectedIndex];
        if (this.price) this.price.textContent = option.dataset.price;

        if (this.isMembershipProduct) {
          this.querySelectorAll('[data-stella-selling-plan-field]').forEach((field) => {
            const isActive = field.dataset.variantId === option.value;
            field.classList.toggle('st-product__selling-plan-field--hidden', !isActive);
            const select = field.querySelector('[data-stella-selling-plan]');
            if (!select) return;
            select.disabled = !isActive;
            if (isActive) {
              select.name = 'selling_plan';
              select.selectedIndex = 0;
            } else {
              select.removeAttribute('name');
            }
          });
        }

        this.updatePurchaseState();
      }

      updateSellingPlan(select) {
        if (select !== this.activeSellingPlan) return;
        const option = select.options[select.selectedIndex];
        if (this.price && option?.dataset.price) this.price.textContent = option.dataset.price;
        this.updatePurchaseState();
      }

      updatePurchaseState() {
        const option = this.variant?.options[this.variant.selectedIndex];
        const available = option?.dataset.available === 'true';
        const sellingPlan = this.activeSellingPlan;
        const hasSellingPlan = Boolean(sellingPlan?.value);
        const canSubmit = !this.submitting && available && (!this.isMembershipProduct || hasSellingPlan);
        const help = this.querySelector('[data-stella-selling-plan-help]');

        if (help) help.hidden = !sellingPlan;
        if (this.submit) this.submit.disabled = !canSubmit;
        if (this.submitText) {
          if (!available) {
            this.submitText.textContent = this.dataset.soldOutLabel;
          } else if (this.isMembershipProduct && !sellingPlan) {
            this.submitText.textContent = '月額プランがありません';
          } else if (this.isMembershipProduct && !hasSellingPlan) {
            this.submitText.textContent = '月払いを選択';
          } else {
            this.submitText.textContent = this.dataset.addLabel;
          }
        }
      }

      updateImage(thumb) {
        const image = this.querySelector('[data-stella-primary-image]');
        if (!image) return;
        image.src = thumb.dataset.imageSrc;
        image.alt = thumb.dataset.imageAlt;
        this.querySelectorAll('[data-stella-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
